<onsip-color-picker
  [defaultColors]="defaultColors"
  [color]="(color | async)!"
  (colorChange)="colorChange.emit($event)"
></onsip-color-picker>
